document.addEventListener('DOMContentLoaded',()=>{
  const variants=document.querySelector('[data-variant-select]');
  if(variants){
    const update=()=>{const o=variants.selectedOptions[0],p=document.querySelector('[data-length-property]'),price=document.querySelector('.purchase strong');if(p)p.value=o.dataset.title;if(price)price.textContent=o.dataset.price};
    variants.addEventListener('change',update);update();
  }

  const satinData=document.querySelector('[data-satin-variants]');
  const satinOptions=Array.from(document.querySelectorAll('[data-product-option]'));
  const satinId=document.querySelector('[data-variant-id]');
  if(satinData&&satinOptions.length&&satinId){
    const satinVariants=JSON.parse(satinData.textContent);
    const price=document.querySelector('.purchase strong');
    const addButton=document.querySelector('.button.add');

    const updateSatinVariant=()=>{
      const selected=satinOptions.map(select=>select.value);
      const variant=satinVariants.find(item=>item.options.every((value,index)=>value===selected[index]));
      if(!variant)return;

      satinId.value=variant.id;
      if(price)price.textContent=variant.price;
      if(addButton){
        addButton.disabled=!variant.available;
        addButton.textContent=variant.available?'In den Warenkorb':'Ausverkauft';
      }
    };

    satinOptions.forEach(select=>select.addEventListener('change',updateSatinVariant));
    updateSatinVariant();
  }
});
